import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import classNames from "classnames";
import { DateRangeInput } from "@blueprintjs/datetime";
import styles from "../../styles/DatePicker.module.scss";
import { MAX_DATE } from "../../constants";
import { formatDate, parseDate } from "../../utils/DatePickerUtil";

export default class DateRangePicker extends Component {
  state = {
    focusDate: this.props.initialMonth || moment().toDate(),
  };
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    dateRange: PropTypes.array.isRequired,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    handleDateChange: PropTypes.func.isRequired,
    defaultIsOpen: PropTypes.bool,
    popoverProps: PropTypes.object,
    initialMonth: PropTypes.instanceOf(Date),
  };

  static defaultProps = {
    placeholder: "DD/MM/YYYY",
    defaultIsOpen: false,
    popoverProps: { usePortal: false },
  };

  componentDidUpdate(prevProps) {
    // Update focusDate if initialMonth prop changes, but only if no date is currently selected
    if (
      prevProps.initialMonth !== this.props.initialMonth &&
      this.props.initialMonth &&
      (!this.props.dateRange || !this.props.dateRange[0])
    ) {
      this.setState({ focusDate: this.props.initialMonth });
    }
  }

  formatDate = (date, locale = "en") => {
    return formatDate(date, "DD/MM/YYYY", locale);
  };

  parseDate = (str, locale = "en") => {
    return parseDate(str, "DD/MM/YYYY", locale);
  };

  onStartDateFocus = () => {
    this.setState({
      focusDate: this.props.dateRange[0] ? this.props.dateRange[0] : moment().toDate(),
    });
  };
  onEndDateFocus = () => {
    this.setState({
      focusDate: this.props.dateRange[1] ? this.props.dateRange[1] : moment().toDate(),
    });
  };

  render() {
    const {
      placeholder,
      handleDateChange,
      dateRange,
      minDate,
      maxDate,
      popoverProps,
      className,
      initialMonth,
      ...rest
    } = this.props;
    return (
      <DateRangeInput
        className={classNames(styles.dateRangePicker, className, {
          [styles.error]: rest.error,
          [styles.disabled]: rest.disabled,
        })}
        dayPickerProps={{ className: styles.daypicker }}
        placeholder={placeholder}
        formatDate={this.formatDate}
        parseDate={this.parseDate}
        shortcuts={false}
        singleMonthOnly
        allowSingleDayRange
        onChange={handleDateChange}
        contiguousCalendarMonths={false}
        value={dateRange}
        initialMonth={this.state.focusDate}
        startInputProps={{ onFocus: this.onStartDateFocus }}
        endInputProps={{ onFocus: this.onEndDateFocus }}
        minDate={minDate}
        //SLATE-1425 Dec7 Anushree:- if maxDate is not passed, then it will take default MAX_DATE
        //maxDate={maxDate}
        maxDate={maxDate ? maxDate : new Date(MAX_DATE)}
        popoverProps={popoverProps}
        highlightCurrentDay={true}
        {...rest}
      />
    );
  }
}
